// extracted by mini-css-extract-plugin
export default {"body":"te7mo","content":"XP3yA"};